import React from 'react';

import getBadgeContent from '@/utils/getBadgeContent';

type VariantType = 'count' | 'dot';
type ColorType = 'gray' | 'primary' | 'error';

type Props = {
  type?: VariantType;
  color?: ColorType;
  badgeContent?: number;
};

const VARIANT_CLASS: Record<VariantType, string> = {
  count:
    'min-h-5 min-w-5 rounded-[99px] px-1.5 text-xs font-bold leading-[150%] text-apps-coreGrayWhite',
  dot: 'h-2 w-2 rounded-full',
};

const COLOR_CLASS: Record<ColorType, string> = {
  gray: 'bg-apps-coreGray02',
  primary: 'bg-apps-corePrimary01',
  error: 'bg-apps-coreProductError01',
};

export default function BadgeNoti({
  type = 'count',
  color = 'gray',
  badgeContent,
}: Props) {
  const className = `inline-flex items-center justify-center ${VARIANT_CLASS[type]} ${COLOR_CLASS[color]}`;

  if (type === 'dot') {
    return <span className={className} />;
  }

  if (!badgeContent) {
    return null;
  }

  return <span className={className}>{getBadgeContent(badgeContent)}</span>;
}
